import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {getCurrencyValue} from 'utils'
import {ConfirmationModal, Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopTemplatePriceChangeModalProps} from './GiftShopTemplatePriceChangeModalProps'

const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${convertUnit(8)};
`

const StyledPriceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${convertUnit(8)};
`

const StyledText = styled(Paragraph)`
  text-align: center;
  line-height: ${convertUnit(31)};
`

export default function GiftShopTemplatePriceChangeModal({
  visible,
  prevPrice,
  newPrice,
  toggleModal,
  onCancel,
  onConfirm,
}: GiftShopTemplatePriceChangeModalProps) {
  const {translate} = useTranslation()

  return (
    <ConfirmationModal
      visible={visible}
      title={translate('giftShop:contentDetailEditPriceChange')}
      text={
        <StyledTextContainer>
          <StyledPriceContainer>
            {prevPrice !== undefined ? (
              <>
                <StyledText fontSize="l">
                  {getCurrencyValue(prevPrice)}
                </StyledText>
                <Icon size={convertUnit(16)} color="gray_5" type="continue" />
              </>
            ) : (
              <StyledText fontSize="l">
                {translate('global:to_direction')}
              </StyledText>
            )}
            <StyledText fontSize="l" fontWeight="bold" color="primary_5">
              {getCurrencyValue(newPrice)}
            </StyledText>
          </StyledPriceContainer>
          <StyledText fontSize="l">{translate('global:areYouSure')}</StyledText>
        </StyledTextContainer>
      }
      confirmText={translate('global:yesImSure')}
      cancelText={translate('global:cancel')}
      toggleModal={() => {
        toggleModal()
        onCancel && onCancel()
      }}
      onConfirm={onConfirm}
    />
  )
}
